import { Action, createReducer, on } from '@ngrx/store';

import * as AppConfigActions from './app-config.actions';

export const appConfigFeatureKey = 'appConfig';


export interface AppConfigState {
  mobileViewMode: boolean;
  error: string;
}

export const initialState: AppConfigState = {
  mobileViewMode: false,
  error: null,
};

const appConfigReducer = createReducer(
  initialState,
  on(AppConfigActions.setMobileViewMode, (state, data) => {
    return {
      ...state,
      mobileViewMode: data.mobileViewMode,
    };
  })
);

export function reducer(state: AppConfigState | undefined, action: Action) {
  return appConfigReducer(state, action);
}
